var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.09028 13.2606C9.19724 13.0204 9.25251 12.7605 9.25251 12.4976C9.25251 12.2348 9.19724 11.9749 9.09028 11.7347L5.75725 4.25191C4.84043 2.46097 6.7392 1.43098 7.8994 2.33204C10.0524 4.0041 15.5073 9.03625 17.9772 11.3325C18.1374 11.4814 18.2652 11.6617 18.3525 11.8621C18.4399 12.0626 18.485 12.279 18.485 12.4976C18.485 12.7163 18.4399 12.9327 18.3525 13.1331C18.2652 13.3336 18.1374 13.5139 17.9772 13.6628C15.5073 15.959 10.0524 20.9912 7.8994 22.6632C6.71046 23.5866 4.85753 22.5009 5.75725 20.7434L9.09028 13.2606Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow-next.959a452822f5949d83c4dfc321ec4238.svg";
export { ForwardRef as ReactComponent };